import { useFlag } from '@calendly/feature-check-react';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { MailSendEnvelopeIcon } from '@calendly/ui/components/icons';
import { useToggleState } from 'hooks/useToggleState';
import { Wrapper, Container, Row, InfoContainer } from '../styles';
import { CrmExternalInvitee } from './crm_external_invitee';
import { LegacyExternalInvitee } from './legacy_external_invitee';
const infoContainerWithIndentCss = "i1mg4qng";
export const ExternalInvitee = ({
  invitee
}) => {
  const [isOpen, toggle] = useToggleState(false);
  const {
    email,
    kind,
    rsvp
  } = invitee;
  const cancelled = rsvp === 'declined';
  const isHost = kind === 'HOST';
  const isCRMContactsPageEnabled = useFlag('crm_contacts_page_to_ai_crm_feature');
  const ExternalInviteeComponent = isCRMContactsPageEnabled ? CrmExternalInvitee : LegacyExternalInvitee;
  return <Wrapper isExpanded={isOpen}>
      <Container>
        <ExternalInviteeComponent cancelled={cancelled} isHost={isHost} invitee={invitee} toggle={toggle} />
      </Container>
      {isOpen && <InfoContainer className={infoContainerWithIndentCss}>
          <Row>
            <MailSendEnvelopeIcon spacingRight={8} />
            <span><FullStoryMask>{email}</FullStoryMask></span>
          </Row>
        </InfoContainer>}
    </Wrapper>;
};

require("./external_invitee.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./external_invitee.js");